module.exports = __webpack_public_path__ + "img/mayBanner_900_ols.cecfe28d.png";